import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const TopInner = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  background: #fff;
  z-index: 200;
  width: 100%;
  height: calc(100vw * (51 / 375));
  display: felx;
  align-items: center;
  // padding: 0 calc(100vw * (17 / 375));
`;
export const Title = styled.h1`
  display: flex;
  justify-content: center;
  width: 100%;
  font-size: calc(100vw * (16 / 375));
  font-weight: 500;
  letter-spacing: 0.32px;
  // margin-left: calc(100vw*(131.2/375));
`;
export const Iconlist = styled.ul`
  display: flex;
  align-items: center;
  margin-left: calc(100vw * (-92 / 375));

  li:last-child {
    margin-right: calc(100vw * (4 / 375));
  }
`;

export const BellIconLink = styled(Link)`
  width: calc(100vw * (44 / 375));
  height: calc(100vw * (44 / 375));
  // object-fit: contain;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const SetIconLink = styled(Link)`
  width: calc(100vw * (44 / 375));
  height: calc(100vw * (44 / 375));
  // object-fit: contain;
  // margin-left: calc(100vw * (19.1 / 375));
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const Alarm = styled.span`
  position: absolute;
  right: calc(100vw * (55 / 375));
  top: calc(100vw * (13 / 375));
  display: inline-block;
  width: calc(100vw * (9 / 375));
  height: calc(100vw * (9 / 375));
  background-color: #de0000;
  border-radius: 50%;
`;

export const IconImg = styled.img`
  width: calc(100vw * (24 / 375));
`;
